var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRequest({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 16,
    viewBox: "0 0 14 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.00006 0C7.37014 0 6.85753 0.512604 6.85753 1.14252C6.85753 1.77467 7.37014 2.28504 8.00006 2.28504C8.63221 2.28504 9.14258 1.77456 9.14258 1.14252C9.14258 0.512604 8.63209 0 8.00006 0ZM0 8.00006C0 8.63221 0.512604 9.14258 1.14252 9.14258C1.77467 9.14258 2.28504 8.63209 2.28504 8.00006C2.28504 7.37014 1.77456 6.85753 1.14252 6.85753C0.512604 6.85753 0 7.37014 0 8.00006ZM13.6585 2.34373C14.1038 2.78905 14.1038 3.51237 13.6585 3.9598C13.211 4.40512 12.4877 4.40512 12.0403 3.9598C11.595 3.51237 11.595 2.78902 12.0403 2.34373C12.4877 1.8963 13.211 1.8963 13.6585 2.34373ZM3.95984 12.0404C4.40516 12.4878 4.40516 13.2112 3.95984 13.6586C3.51241 14.1039 2.78906 14.1039 2.34377 13.6586C1.89634 13.2112 1.89634 12.4878 2.34377 12.0404C2.78909 11.5951 3.51241 11.5951 3.95984 12.0404ZM2.34377 2.34373C1.89634 2.78905 1.89634 3.51237 2.34377 3.9598C2.78909 4.40512 3.51241 4.40512 3.95984 3.9598C4.40516 3.51237 4.40516 2.78902 3.95984 2.34373C3.51241 1.8963 2.78906 1.8963 2.34377 2.34373ZM8.0001 13.715C7.37018 13.715 6.85757 14.2276 6.85757 14.8575C6.85757 15.4896 7.37018 16 8.0001 16C8.63225 16 9.14262 15.4895 9.14262 14.8575C9.14262 14.2276 8.63213 13.715 8.0001 13.715Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRequest);
export default __webpack_public_path__ + "static/media/request.2957c7ba1ff7eabf9e05306253b372f1.svg";
export { ForwardRef as ReactComponent };